import FormInput from '@/components/form-input'
import FormWrapper from '@/components/form-wrapper'
import FormActions from '@/components/form-actions'
import FormCheckbox from '@/components/form-checkbox'
import FormSelect from '@/components/form-select'
import FormTextarea from '@/components/form-textarea'

export default {
  components: {
    FormInput,
    FormWrapper,
    FormActions,
    FormCheckbox,
    FormSelect,
    FormTextarea,
  },
}
